import { AddOn } from '@acorn-portal/shared/src/services/renewalsApi';
import { formatCurrency } from '@acorn-portal/shared/src/utils/formatter';

const MapOutOptionsExcess = (options: AddOn[]) => {
	return options.map((option) => {
		const addOnCodeParts = option.addOnCode.split('_');
		const lastPart = addOnCodeParts[addOnCodeParts.length - 1];
		const lastPartNumber = Number(lastPart);
		const lastPartOfAddOnCode = lastPart && !isNaN(lastPartNumber) ? formatCurrency(lastPartNumber) : null;
		return {
			label: lastPartOfAddOnCode ?? option.addOnDescription,
			value: option.underwrittenDataPointId,
		};
	});
};

export default MapOutOptionsExcess;
